import { graphql } from "gatsby"
import PropTypes from "prop-types"
import React, { useState } from "react"
import ContactSalesModal from "components/ContactSalesModal"
import { openModal } from "utils/openModal"
import { usePageAssets } from "hooks/usePageAssets"
import Container from "components/ui/Container"
import CTA from "components/ui/CTA"

function CTASection({
  label,
  heading,
  description,
  ctaButton,
  children,
  splitLayout,
  noBackground,
}) {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false)
  const isContactModal = ctaButton?.contactModal
  const { getAsset } = usePageAssets()
  const background = noBackground
    ? null
    : getAsset("single-cta-preset-background")
  return (
    <Container section>
      <CTA
        background={background}
        label={label}
        title={heading}
        description={description}
        linkText={ctaButton?.buttonLabel}
        linkUrl={ctaButton?.url}
        onButtonClick={
          isContactModal ? openModal(setIsContactModalOpen) : undefined
        }
        trackClick={ctaButton?.trackingName}
        size="wide"
        dark
        splitLayout={splitLayout}
      >
        {children}
      </CTA>
      {isContactModal && (
        <ContactSalesModal
          isOpen={isContactModalOpen}
          onClose={() => setIsContactModalOpen(false)}
          sourcePage={ctaButton?.contactModalSource || ""}
        />
      )}
    </Container>
  )
}

CTASection.propTypes = {
  label: PropTypes.string,
  heading: PropTypes.string,
  description: PropTypes.string,
  ctaButton: PropTypes.shape({
    buttonLabel: PropTypes.string,
    url: PropTypes.string,
    trackingName: PropTypes.string,
  }),
  /** Optional children to render instead of button (e.g., a form) */
  children: PropTypes.node,
  /** If true, use split layout with text on left, children on right */
  splitLayout: PropTypes.bool,
  /** If true, skip the background image and use plain dark blue */
  noBackground: PropTypes.bool,
}

export default CTASection

export const query = graphql`
  fragment CTASection on ContentfulCtaSection {
    id
    __typename
    label
    heading
    description
    ctaButton {
      buttonLabel
      trackingName
      url
    }
  }
`
